export enum SuccessMessage {
  ReviewPosted = 'ReviewPosted',
  TourOrderCreated = 'TourOrderCreated',
  TourSelectionClaimCreated = 'TourSelectionClaimCreated',
  SiteFeedbackPosted = 'SiteFeedbackPosted'
}
